export let PRIVILEDGES = [
        // manager level Templates
        {role:'manager', name:'Dashboard', routerLink:"/dashboard", icon:'dashboard'},
        {role:'manager', name:'Customers', routerLink:'/customers', icon:'customer'},
        {role:'manager', name:'Transactions ', routerLink:'/transactions', icon:'customer'},
        {role:'manager', name:'Quotes', routerLink:'/quotes', icon:'quote'},
        {role:'manager', name:'Report', routerLink:'/report', icon:'quote'},


        // admin level Templates
        {role:'admin', name:'Dashboard', routerLink:"/dashboard", icon:'dashboard'},
        {role:'admin', name:'Admin', routerLink:'/signupmanager', icon:'manager'},
        // {role:'admin', name:'Broker-Admin', routerLink:'/add-broker-admin', icon:'agent'},
        // {role:'admin', name:'Broker-User', routerLink:'/add-broker', icon:'agent'},  
        {role:'admin', name:'Agents', routerLink:'/registeredagents', icon:'agent'},
        {role:'admin', name:'Customers', routerLink:'/customers', icon:'customer'},
        {role:'admin', name:'Transactions ', routerLink:'/transactions', icon:'customer'},
        {role:'admin', name:'Report', routerLink:'/report', icon:'quote'},
        {role:'admin', name:'Billing', routerLink:'/billing', icon:'quote'},
        //{role:'admin', name:'Claims', routerLink:'/claimsportal', icon:'claim'},

        // {role:'admin', name:'Contacts', routerLink:"/contacts", icon:'import_contacts'},
        //  {role:'admin', name:'Notifications', routerLink:"/notifications", icon:'notification'},


        // {role:'admin', name:'Posts', routerLink:'/posts', maticon:'person'},
        
    ]


     //for bottom notifications and messages
     export let PRIVILEDGESNEW = [
        // manager level Templates

        {role:'manager', name:'Notifications', routerLink:"/notifications", icon:'notification'},,
        {role:'manager', name:'Messages', routeLink:'/messages', icon:'messages'},

        // admin level Templates

    // {role:'admin', name:'Contacts', routerLink:"/contacts", icon:'import_contacts'},
      {role:'admin', name:'Notifications', routerLink:"/notifications", icon:'notification'},
      {role:'admin', name:'Messages', routerLink:"/messages", icon:'messages'},

     ]
    // {role:'admin', name:'Posts', routerLink:'/posts', maticon:'person'},



    //for reference later
    // {role:'admin', name:'Dashboard', routerLink:"/dashboard", icon:'library_add'},
    //     // {role:'admin', name:'Managers', routerLink:'/signupmanager', icon:'view_list'},
    //     {role:'admin', name:'Agents', routerLink:'/agentadmission', icon:'person'},
    //     {role:'admin', name:'Customers', routerLink:'/customers', icon:'content_paste'},
    //     {role:'admin', name:'Quotes', routerLink:'/quotes', icon:'library_books'},
    //     {role:'admin', name:'Claims', routerLink:'/claimsportal', icon:'accessibility_new'},
    //     {role:'admin', name:'Claims', routerLink:'/claimsportal', icon:'notifications'},
        // {role:'admin', name:'Contacts', routerLink:"/contacts", icon:'import_contacts'},
        // {role:'admin', name:'Notifications', routerLink:"/notifications", icon:'contact_phone'},
